import { createContext, useContext, type ReactNode } from 'react';

export type SidebarResetSlotValue = {
  /** Desktop cards, collection, and proxy sidebars pin Reset below the scroller. */
  enabled: boolean;
  element: HTMLElement | null;
};

const SidebarResetSlotContext = createContext<SidebarResetSlotValue>({
  enabled: false,
  element: null,
});

export function SidebarResetSlotProvider({
  value,
  children,
}: {
  value: SidebarResetSlotValue;
  children: ReactNode;
}) {
  return (
    <SidebarResetSlotContext.Provider value={value}>{children}</SidebarResetSlotContext.Provider>
  );
}

export function useSidebarResetSlot(): SidebarResetSlotValue {
  return useContext(SidebarResetSlotContext);
}
